export enum KEY_NUM {
    ENTER=13,
    ALT = 18,
   RIGHT_ARROW = 39,
   LEFT_ARROW = 37,
    D = 68,
    F = 70,
    L = 76,
    M = 77,
    O = 79,
    R = 82,
    S = 83
}
